import React from "react";
import TableView from './table/TableView'
import { Wrapper } from "./OrderHistoryPage.styled";

export default function OrderHistoryPage() {

  return (
    <Wrapper>
      <TableView />
    </Wrapper>
  );
}
